import { render, staticRenderFns } from "./RequisicaoPrincipal.vue?vue&type=template&id=19cf2320&"
import script from "./RequisicaoPrincipal.vue?vue&type=script&lang=js&"
export * from "./RequisicaoPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports